import { Injectable } from '@angular/core';
import { debounceTime } from 'rxjs/operator/debounceTime';

@Injectable()
export class MessageService {

  public alerts: Array<IAlert> = [];
  private maxId: number = 0;

  constructor() { }

  /** close all alerts */
  public reset() {
    this.alerts = [];
  }

  /** close the given alert */
  public closeAlert(alert: IAlert) {
    const index: number = this.alerts.indexOf(alert);
    this.alerts.splice(index, 1);
  }

  /**
   * add a new alert of given type
   * @param messageS - message string
   * @param typeS - type of message
   */
  public addAlert(messageS: string, typeS: string) {
    let myAlert = {
      id: this.maxId++,
      type: typeS,
      message: messageS
    };
    this.alerts.push(myAlert);
  }

  /**
   * add a new alert of given type lasting for given time
   * @param messageS - message string
   * @param typeS - type of message
   * @param timeout - duration in ms
   */
  public addAlertWithTimeout(messageS: string, typeS: string, timeout: number) {
    let myAlert = {
      id: this.maxId++,
      type: typeS,
      message: messageS
    };
    this.alerts.push(myAlert);
    setTimeout(() => this.closeAlert(myAlert), timeout);
  }

}

export interface IAlert {
  id: number;
  type: string;
  message: string;
}